var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"heading",class:_vm.cssClasses,attrs:{"tabindex":"-1","role":"heading","data-cy":"isotope-header","aria-level":"1"}},[_vm._v("\n    "+_vm._s(_vm._f("sitetext")(_vm.siteText))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }